export interface IAccountsReceivable {
    centerId: number
    centerAlias: string
    organType: number | null
    centerPaysViaAch: boolean
    centerExecutiveSponsor: string
    lastLateNoticeDate: string
    pending0To30: number
    pending31To45: number
    pending46To60: number
    pending61To90: number
    pending91To120: number
    pending121To150: number
    pendingOver90: number
    pendingOver150: number
    totalDelinquent: number
    ccbApTotal: number
    totalOutstanding: number
}